import { Primitive } from "@radix-ui/react-primitive";
import * as React from "react";

type PrimitiveLabelProps = React.ComponentProps<typeof Primitive.label>;
// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface LabelProps extends PrimitiveLabelProps {}

const Label = (props: LabelProps) => {
  return (
    <Primitive.label
      {...props}
      onMouseDown={(event) => {
        // only prevent text selection if clicking inside the label itself
        const target = event.target as HTMLElement;
        if (target.closest("button, input, select, textarea")) return;

        props.onMouseDown?.(event);
        // prevent text selection when double clicking label
        if (!event.defaultPrevented && event.detail > 1) event.preventDefault();
      }}
    />
  );
};

export { Label };
export type { LabelProps };
